export default function AboutSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Looking for <strong>professional carpet cleaners in Escondido</strong>?
          </h2>
        </header>

        <article className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Video */}
          <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
            <iframe 
              src="https://www.youtube.com/embed/H-77yb82xro?rel=0" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              allowFullScreen
              className="w-full h-full"
              title="Steam Cleaning of Carpets & Furniture by Blue Team Home Services"
              aria-label="Blue Team carpet and furniture steam cleaning demonstration video"
            ></iframe>
          </div>

          {/* Content */}
          <div>
            <p className="text-lg text-gray-700 mb-6">
              Look no further! We are <strong>carpet cleaning Escondido</strong> industry leaders. Our professional <strong>steam cleaning services</strong> are based on the highest standards and 100% customer satisfaction.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              Blue Team Home Services offers competitive prices for <strong>carpet cleaning</strong> and <strong>furniture cleaning services in Escondido</strong>. For example, carpet cleaning of 2 Areas for $99, and steam cleaning of a regular-size sofa starts at $89.00.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              When it comes to professional cleaning, <strong>carpet cleaning</strong> is one of the most challenging and labor intensive processes. To be done correctly, it requires special training, practiced skills, professional equipment, safe cleaning products and years of experience.
            </p>
            <p className="text-lg text-gray-700 font-semibold">
              Blue Team Home Services specialists have it all! We are <strong>Carpet Cleaning Escondido</strong> experts!
            </p>
          </div>
        </article>
      </div>
    </section>
  );
}
